import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import CycleOrder, { IStateProps, IDispatchProps, IOwnProps } from './CycleOrder'
import { IStoreState } from '../../services/store/IStoreState'
import { resetLastAffectedOrder } from '../../services/store/actions/dashboard/ResetLastAffectedOrder'
import { DashboardAction, resetFailedOrderId } from '../../services/store/actions/dashboard/DashboardAction'
import FailedOrderReason from '../../constants/FailedOrderReason'

function mapStateToProps(state: IStoreState): IStateProps {
  return {
    productsInProcessing: state.Dashboard.productsInProcessing,
    lastAffectedOrderId:  state.Dashboard.lastAffectedOrder?.orderId || null,
    notProcessedOrderId:  state.Dashboard.failedOrder?.reason === FailedOrderReason.NOT_ALL_PRODUCTS_PROCESSED
      ? state.Dashboard.failedOrder.orderId : undefined,
  }
}

function mapDispatchToProps(dispatch: Dispatch<DashboardAction>): IDispatchProps {
  return {
    resetLastAffectedOrder: () => dispatch(resetLastAffectedOrder()),
    resetFailedOrderId: () => dispatch(resetFailedOrderId()),
  }
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(CycleOrder)
